import { TransferBaseResponseDto } from '@api/external-transfer';

export class ImportToFusionResponseDto extends TransferBaseResponseDto {}
